import { Editor } from '@tiptap/react'
import React, { Fragment } from 'react'
import EditorMenuItem, { IEditorMenuItem } from './EditorMenuItem'
import { t } from '@lingui/macro';

export const EditorMenuBar: React.FC<{ editor: Editor }> = ({ editor }) => {
  const items: IEditorMenuItem[] = [
    { icon: 'bold', title: t`Bold (CTRL+B)`, action: () => editor.chain().focus().toggleBold().run(), isActive: () => editor.isActive('bold'), },
    { icon: 'italic', title: t`Italic (CTRL+I)`, action: () => editor.chain().focus().toggleItalic().run(), isActive: () => editor.isActive('italic'), },
    { icon: 'strikethrough', title: t`Strike (CTRL+SHIFT+S)`, action: () => editor.chain().focus().toggleStrike().run(), isActive: () => editor.isActive('strike'), },
    // { icon: 'code-view', title: t`Code`, action: () => editor.chain().focus().toggleCode().run(), isActive: () => editor.isActive('code'), },
    { icon: 'mark-pen-line', title: t`Highlight (CTRL+SHIFT+H)`, action: () => editor.chain().focus().toggleHighlight().run(), isActive: () => editor.isActive('highlight'), },
    { type: 'divider', },
    { icon: 'h-1', title: t`Heading 1 (CTRL+ALT+1)`, action: () => editor.chain().focus().toggleHeading({ level: 1 }).run(), isActive: () => editor.isActive('heading', { level: 1 }), },
    { icon: 'h-2', title: t`Heading 2 (CTRL+ALT+2)`, action: () => editor.chain().focus().toggleHeading({ level: 2 }).run(), isActive: () => editor.isActive('heading', { level: 2 }), },
    { icon: 'paragraph', title: t`Paragraph`, action: () => editor.chain().focus().setParagraph().run(), isActive: () => editor.isActive('paragraph'), },
    { icon: 'list-ordered', title: t`Ordered List (CTRL+SHIFT+7)`, action: () => editor.chain().focus().toggleOrderedList().run(), isActive: () => editor.isActive('orderedList'), },
    { icon: 'list-unordered', title: t`Bullet List (CTRL+SHIFT+8)`, action: () => editor.chain().focus().toggleBulletList().run(), isActive: () => editor.isActive('bulletList'), },
    { icon: 'list-check-2', title: t`Task List (CTRL+SHIFT+9)`, action: () => editor.chain().focus().toggleTaskList().run(), isActive: () => editor.isActive('taskList'), },
    { icon: 'code-box-line', title: t`Code Block`, action: () => editor.chain().focus().toggleCodeBlock().run(), isActive: () => editor.isActive('codeBlock'), },
    { type: 'divider', },
    { icon: 'double-quotes-l', title: t`Blockquote`, action: () => editor.chain().focus().toggleBlockquote().run(), isActive: () => editor.isActive('blockquote'), },
    { icon: 'separator', title: t`Horizontal Rule`, action: () => editor.chain().focus().setHorizontalRule().run(), },
    // { type: 'divider', },
    // { icon: 'text-wrap', title: t`Hard Break`, action: () => editor.chain().focus().setHardBreak().run(), },
    { icon: 'format-clear', title: t`Clear Format`, action: () => editor.chain().focus().clearNodes().unsetAllMarks().run(), },
    { type: 'divider', },
    { icon: 'arrow-go-back-line', title: t`Undo (CTRL+Z)`, action: () => editor.chain().focus().undo().run(), },
    { icon: 'arrow-go-forward-line', title: t`Redo (CTRL+Y)`, action: () => editor.chain().focus().redo().run(), },
    { type: 'divider', },
    { icon: 'table-2', title: t`Add Table`, action: () => editor.commands.insertTable({ rows: 3, cols: 3 }) },
  ];

  var tableItems: IEditorMenuItem[] = [];
  if (editor.can().addRowAfter && editor.can().addRowAfter()) {
    tableItems = [
      { icon: 'insert-row-top', title: t`Add Row Above`, action: () => editor.commands.addRowBefore() },
      { icon: 'insert-row-bottom', title: t`Add Row Below`, action: () => editor.commands.addRowAfter() },
      { icon: 'insert-column-left', title: t`Add Column Left`, action: () => editor.commands.addColumnBefore() },
      { icon: 'insert-column-right', title: t`Add Column Right`, action: () => editor.commands.addColumnAfter() },
      { icon: 'text', title: t`Toggle Header Cell`, action: () => editor.commands.toggleHeaderCell() },
      { icon: 'delete-row', title: t`Delete Row`, action: () => editor.commands.deleteRow() },
      { icon: 'delete-column', title: t`Delete Column`, action: () => editor.commands.deleteColumn() },
      { icon: 'delete-bin-line', title: t`Delete Table`, action: () => editor.commands.deleteTable() },
    ];
  }

  return (
    <div className='tiptap-editor'>
      <div className="editor__header">
        {items.map((item, index) => (
          <Fragment key={index}>
            {item.type === 'divider' ? <div className="divider" /> : <EditorMenuItem {...item} />}
          </Fragment>
        ))}
        <div className='table-items'>
          {tableItems.map((item, index) => (
            <Fragment key={index}>
              {item.type === 'divider' ? <div className="divider" /> : <EditorMenuItem {...item} />}
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}